

export class RequestDecriptionClass implements IRequestDecriptionClass {
    id!: number;
    message!: string | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    createdOn!: Date | undefined;

    constructor(data?: IRequestDecriptionClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestDecriptionClass {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDecriptionClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IRequestDecriptionClass {
    id: number;
    message: string | undefined;
    userId: number | undefined;
    userName: string | undefined;
    createdOn: Date | undefined;
}

